export const SLIDER_CONSTS = {
    GET_SLIDER: "GET_SLIDER",
    CREATE_SLIDE: "CREATE_SLIDE",
    UPDATE_SLIDER_ITEMS_POSITION: "UPDATE_SLIDER_ITEMS_POSITION",
    GET_SLIDE_BY_ID: "GET_SLIDE_BY_ID",
    UPDATE_SLIDE_BY_ID: "UPDATE_SLIDE_BY_ID",
    DELETE_SLIDE_BY_ID: "DELETE_SLIDE_BY_ID",
};